import { lazy, Suspense } from "react";

const Signup = lazy(() => import("./Signup"));
const Signin = lazy(() => import("./Signin"));
const ForgotPassword = lazy(() => import("./ForgotPassword"));
const Error404 = lazy(() => import("./Error"));

const sessionsRoutes = [
  {
    path: "/signup",
    element: (
      <Suspense>
        <Signup />
      </Suspense>
    ),
  },
  {
    path: "/signin",
    element: (
      <Suspense>
        <Signin />
      </Suspense>
    ),
  },
  {
    path: "/forgot-password",
    element: (
      <Suspense>
        <ForgotPassword />
      </Suspense>
    ),
  },
  {
    path: "/404",
    element: (
      <Suspense>
        <Error404 />
      </Suspense>
    ),
  },
];

export default sessionsRoutes;
